var map = {
	"./arnold-joanna.png": "./src/assets/testimonials/arnold-joanna.png",
	"./conrad-caroline.png": "./src/assets/testimonials/conrad-caroline.png",
	"./moh-linda.png": "./src/assets/testimonials/moh-linda.png",
	"./rodrigue-linda.png": "./src/assets/testimonials/rodrigue-linda.png",
	"./woman-smiling.jpg": "./src/assets/testimonials/woman-smiling.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/testimonials sync recursive ^\\.\\/.*$";